import React from "react";

const MatchesList = ({
  matches,
  loading,
  authUser,
  respondMatchRequest,
}) => {
  return (
    <div className="mt-6">
      <h3 className="text-xl font-semibold text-gray-800">Match của bạn</h3>
      {loading ? (
        <p className="text-center text-gray-500">Đang tải Match...</p>
      ) : matches.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-2">
          {matches
            .filter((match, index, self) => {
              const pairKey = [
                String(match.userId._id || match.userId),
                String(match.likedUserId._id || match.likedUserId),
              ]
                .sort()
                .join("-");
              return index === self.findIndex((m) => {
                const mPairKey = [
                  String(m.userId._id || m.userId),
                  String(m.likedUserId._id || m.likedUserId),
                ]
                  .sort()
                  .join("-");
                return mPairKey === pairKey;
              });
            })
            .map((match) => {
              const isReceiver =
                String(match.likedUserId._id || match.likedUserId) === String(authUser._id);
              const displayUser = isReceiver ? match.userId : match.likedUserId;
              return (
                <div key={match._id} className="border p-4 rounded-lg shadow">
                  <img
                    src={displayUser?.avatar || "https://placehold.co/100"}
                    alt={displayUser?.name || "User"}
                    className="w-20 h-20 rounded-full mx-auto"
                    onError={(e) => (e.target.src = "https://placehold.co/100")}
                  />
                  <p className="text-center mt-2">
                    <strong>{displayUser?.name || "Unknown"}</strong>
                  </p>
                  {match.status === "pending" && isReceiver ? (
                    <div className="flex justify-center gap-2 mt-2">
                      <button
                        onClick={() => respondMatchRequest(match._id, "accept")}
                        className="px-3 py-1 bg-green-500 text-white rounded hover:bg-green-600"
                        disabled={loading}
                      >
                        Chấp nhận
                      </button>
                      <button
                        onClick={() => respondMatchRequest(match._id, "reject")}
                        className="px-3 py-1 bg-red-500 text-white rounded hover:bg-red-600"
                        disabled={loading}
                      >
                        Từ chối
                      </button>
                    </div>
                  ) : match.status === "matched" ? (
                    <p className="text-center text-green-600 mt-2">Đã Match!</p>
                  ) : (
                    <p className="text-center text-gray-500 mt-2">Đang chờ phản hồi</p>
                  )}
                </div>
              );
            })}
        </div>
      ) : (
        <p className="text-center text-gray-500">Bạn chưa có Match nào.</p>
      )}
    </div>
  );
};

export default MatchesList;